module.exports = __webpack_public_path__ + "static/media/buy_report_service_2.11543735.png";